import React from 'react'
import { useShallow } from 'zustand/react/shallow'

import { useNavigationStore } from '../state/navigationStore'
import { I_SystemPost } from '../state/wpDataStore'
import { SystemCardIcon } from './Svg'
import { SystemAttributes } from './SystemAttributes'

const SystemCard = ({ systemPost }: { systemPost: I_SystemPost }) => {
  const { id, title, excerpt, acf } = systemPost
  const iconImage = acf?.icon

  const {
    setSystemModalOpen,
    setSelectedSystemPostId,
    setSelectedCasePostId,
    setCaseModalOpen,
  } = useNavigationStore(
    useShallow((state) => ({
      setSystemModalOpen: state.setSystemModalOpen,
      setSelectedSystemPostId: state.setSelectedSystemPostId,
      setSelectedCasePostId: state.setSelectedCasePostId,
      setCaseModalOpen: state.setCaseModalOpen,
    }))
  )

  return (
    <div className='system-card'>
      {/* <div className='system-card__icon-wrapper'>
        {iconImage?.url ? (
          <img src={iconImage.url} alt={iconImage.alt || ''} />
        ) : (
          <SystemCardIcon />
        )}
      </div> */}

      <h4
        className='system-card__title'
        onClick={() => {
          setSelectedSystemPostId(id)
          setSystemModalOpen(true)
        }}
      >
        {title?.rendered || `#${id}`}
      </h4>

      {excerpt && excerpt.rendered && (
        <div
          className='system-card__excerpt'
          dangerouslySetInnerHTML={{ __html: excerpt.rendered }}
        />
      )}

      {/* Attributes */}
      <SystemAttributes systemPost={systemPost} />
    </div>
  )
}

export { SystemCard }
